import { LitElement, css, html } from 'lit';
import { customElement, property, query } from 'lit/decorators';

import { PaperToastElement } from '@polymer/paper-toast/paper-toast';

@customElement('downloadable-error-toast')
export class DownloadableErrorToastElement extends LitElement {
    @query('#toast')
    toastElement!: PaperToastElement;

    @property({ type: String })
    text?: string;

    @property({ type: String })
    url?: string;

    @property({ type: Number })
    errorCount = 0;

    showDownloadableToast(url: string, text: string, errorCount: number) {
        this.url = url;
        this.text = text;
        this.errorCount = errorCount;
        this.toastElement.open();
    }

    handleClose() {
        this.toastElement.close();
    }

    render() {
        return html`
            <paper-toast id="toast" text=${this.text} duration="0">
                <button class="modalCloseButton" @click="${this.handleClose}"></button>
                <a href=${this.url} download="errors.csv">Download information for the ${this.errorCount} error(s)</a>
            </paper-toast>
        `;
    }

    static get styles() {
        return css`
            #toast {
                --paper-toast-background-color: var(--main-moon-color);
            }

            .modalCloseButton {
                box-sizing: content-box;
                width: 0.75em;
                height: 0.75em;
                padding: 0.25em 0.25em;
                color: var(--main-primary-color);
                background: transparent
                    url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/%3e%3c/svg%3e")
                    center/0.75em auto no-repeat;
                border: 0;
                border-radius: 0.5rem;
                opacity: 0.5;
                position: absolute;
                top: 0;
                right: 0;
                font-size: 1.25rem;
                cursor: pointer;
            }

            .modalCloseButton:hover {
                opacity: 0.75;
            }
        `;
    }
}
